import { Anchor, Box, Breadcrumbs, Button, createStyles, Flex, Grid, Image, Menu, Paper, Tabs, Title, Text, Avatar } from "@mantine/core";
import { IconCaretDown, IconPlayerPause, IconPlayerPlay } from "@tabler/icons-react";
import { useLocation, useNavigate, useNavigationType, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { AppState } from "../../../store/types/appState";
import { circularPlatformLogo, getIntegrationTypes, platformLogo } from "../../../utils";
import { useEffect, useState } from "react";
import { useMedplum } from "@medplum/react";
import { useDispatch } from "react-redux";
import { updateProfile } from "../../../store/actions/ProfileActions";
import { MedplumClient } from "@medplum/core";
import { PauseCircle, PlayCircle } from "react-feather"
import aiStartsSvg from "../../../assets/img/mdi_stars.svg"
export interface TabInterface {
  currentTab: string;
  patientName: String;
  patient: any
  showSummaryClick?:any
  showSummaryDisable?: boolean
}

const useStyles = createStyles(() => ({
  button: {
    textAlign: "right",
    marginTop: "32px",
    marginBottom: "10px",
  },
}));


function PatientTabs({ currentTab, patientName, patient,showSummaryClick, showSummaryDisable = false }: TabInterface): JSX.Element {
  const navigate = useNavigate();
  const loc = useLocation();
  const nt = useNavigationType();
  const medplum = useMedplum();
  const dispatch = useDispatch();
  const { patientId } = useParams();
  const [platforms, setPlatforms] = useState<string[]>([]);
  const { classes } = useStyles();
  const [timer, setTimer] = useState<any>(0);
  const [isMonitoring, setIsMonitoring] = useState<boolean>(false);
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const [isloading, setIsloading] = useState<boolean>(false);
  const [showTimer, setShowTimer] = useState<boolean>(false);
  const userProfile = useSelector((state: AppState) => state) as any;

  const updateUserProfile = async () => {
    if (userProfile?.app?.profile) {
      const platforms = getIntegrationTypes(
        userProfile.app.profile.extension as any
      );
      setPlatforms(platforms);
    }
  }

  useEffect(() => {
    const tmr = patient?.extension?.find((ext: any) => ext?.url === "timer")?.valueString
    if (tmr) setTimer(parseInt(tmr))
  }, [patient]);

  useEffect(() => {
    updateUserProfile()
    // const popHandler = () => {
    //   saveTimer(medplum, patient, timer)
    //   window.removeEventListener('popstate', popHandler)
    // }
    // window.addEventListener('popstate', popHandler);
  }, [userProfile]);

  useEffect(() => {
    if (isRunning) {
      const start = Date.now();
      setTimeout(() => {
        const diff = Date.now() - start;
        setTimer(timer + Math.floor(diff / 1000))
      }, 1000);
    }
  }, [timer, isRunning]);

  const handleMonitorClick = () => {
    if (isMonitoring) {
      setIsRunning(false);
      setIsloading(true);
      saveTimer(medplum, patient, timer).then(() => {
        setIsloading(false);
        setIsMonitoring(false);
      });
    } else {
      setShowTimer(true);
      setIsRunning(true);
      setIsMonitoring(true);
    }
  }

  const currentURL = window.location.href;
  const parts = currentURL.split("/");

  const secondLastPart = parts[parts.length - 3];
  const lastPart = patientName

  const items = [
    { title: secondLastPart, href: "/patient", style: { color: "#818999" } },
    {
      title: lastPart,
      href: "",
      style: { color: "#262930" },
    },
  ].map((item, index) => (
    <Anchor style={item.style} size="lg" href={item.href} key={index}>
      {item.title}
    </Anchor>
  ));


  /**
   * Handles a tab change event.
   * @param tabname - The new tab name.
   */
  const onTabChange = (tabname: string) => {
    navigate(`/patient/${tabname}/${patientId}`);
  };

  const tabs = ["Details", "Edit", "FHIR Response"];
  return (
    <Paper
      sx={{
        marginTop: "20px",
        borderRadius: "8px",
        marginLeft: "40px",
        marginRight: "40px",
        padding: "20px",
        background: "'#FFF",
        boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
      }}
      shadow="sm"
    >
      <Box sx={{ marginBottom: "15px" }}>
        <Breadcrumbs>{items}</Breadcrumbs>
      </Box>

      <Flex justify="space-between" align={"center"}>
        <Grid miw="600px">
          <Grid.Col span={1} style={{ marginTop: "8px" }}>
            <Avatar
              radius="xl"
              src={
                patient?.identifier?.find(
                  (i: any) => i.system === "profile-pic"
                )?.value ?? null
              }
            ></Avatar>
          </Grid.Col>
          <Grid.Col span={10}>
            <Title sx={{ fontSize: "26px", fontWeight: "bold" }}>
              {patientName}
            </Title>
          </Grid.Col>
        </Grid>
        {/* <Menu shadow="md" width={200}>
          {platforms?.length > 0 && (
            <Menu.Target>
              <Button
                variant="outline"
                leftIcon={
                  <Image
                    style={{ height: "24px", width: "24px", marginTop: "5px" }}
                  />
                }
                rightIcon={<IconCaretDown />}
              >
                Connected
              </Button>
            </Menu.Target>
          )}
          <Menu.Dropdown>
            {platforms.map((platform: string) => (
              <>
                <Menu.Item
                  icon={
                    <Image
                      src={circularPlatformLogo[platform]}
                      style={{
                        height: "24px",
                        width: "24px",
                        marginTop: "5px",
                      }}
                    />
                  }
                >
                  {platform}
                </Menu.Item>
                <Menu.Divider />
              </>
            ))}
          </Menu.Dropdown>
        </Menu> */}

        <Grid>
          <Grid.Col span={1} style={{ marginRight: "10px" }}>
            {isMonitoring ? (
              isRunning ? (
                <PauseCircle
                  color="#6e6e6e"
                  style={{ height: "28px", width: "28px", marginTop: "6px" }}
                  onClick={() => setIsRunning(false)}
                ></PauseCircle>
              ) : (
                <PlayCircle
                  color="#6e6e6e"
                  style={{ height: "28px", width: "28px", marginTop: "6px" }}
                  onClick={() => setIsRunning(true)}
                ></PlayCircle>
              )
            ) : null}
          </Grid.Col>
          {/* {showTimer && (
            <Grid.Col
              span={4}
              style={{
                marginLeft: "6px",
                paddingLeft: "0px",
                minWidth: "110px",
              }}
            >
              <Text
                style={{
                  marginTop: "8px",
                  fontWeight: "bolder",
                  color: "rgb(75 75 75)",
                  fontSize: "16px",
                }}
              >
                {Math.floor(timer / 60)}:{timer % 60 < 10 ? 0 : ""}
                {timer % 60} for RPM
              </Text>
            </Grid.Col>
          )} */}
          <Grid.Col
            span={2}
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              height: "42px",
            }}
          >
            {showTimer && (
              <Grid.Col
                span={4}
                style={{
                  paddingLeft: "0px",
                  minWidth: "110px",

                }}
              >
                <Text
                  style={{
                    fontWeight: "bolder",
                    color: "rgb(75 75 75)",
                    fontSize: "16px",
                                   }}
                >
                  {Math.floor(timer / 60)}:{timer % 60 < 10 ? 0 : ""}
                  {timer % 60} for RPM
                </Text>
              </Grid.Col>
            )}
            <Button variant="outline" onClick={showSummaryClick} disabled={showSummaryDisable} >
              <img src={aiStartsSvg} style={{ marginRight: "8px" }} /> Try AI
              Recipes
            </Button>
            <Button
              disabled={isloading}
              variant="filled"
              onClick={handleMonitorClick}
              color={isMonitoring ? "#1B75BC" : "#1B75BC"}
              mr={16}
            >
              {/* <Box
      // component="img"
      // src={
      //   platformLogo[integrationType[0]?.replace(/\s/g, "")?.toLowerCase()]
      // }
      // className={classes.platformLogo}
      /> */}
              {isMonitoring ? "Finish " : "Start"}{" "}
              <span style={{ fontWeight: "bolder", marginLeft: "5px" }}>
                Monitoring
              </span>
            </Button>
          </Grid.Col>
        </Grid>
      </Flex>

      <Tabs value={currentTab} onTabChange={onTabChange}>
        <Tabs.List
          style={{
            whiteSpace: "nowrap",
            flexWrap: "nowrap",
            width: "fit-content",
            marginBottom: "30px",
          }}
        >
          {tabs.map((t) => (
            <Tabs.Tab
              key={t}
              value={t}
              sx={{
                color: currentTab === t ? "#1B75BC" : "#99A0AD",
                fontFamily: "Montserrat",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "22px",
              }}
            >
              {t}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>
    </Paper>
  );
}


async function saveTimer(medplum: MedplumClient, pDetails: any, timer: number) {
  const eArray = pDetails?.extension?.filter((d: any) => d?.url != "timer");
  eArray.push({
    url: "timer",
    valueString: timer.toString(),
  });
  await medplum
    .updateResource({
      ...pDetails,
      extension: eArray
    }

    )
    .then((res: any) => {
      console.log(res);
    })
    .catch((err: any) => {
      console.log(err);
    });
}


export default PatientTabs;
